<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Remove exchanges</ng-container>

    <ng-container dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row">
            <div class="col-12 pb-2">
                <span class="value pl-3 exchange-subtitle">Exchange name</span>
            </div>

            <div *ngFor="let exchange of form.controls"
                 [rule]="permissionRule" appCheckPermissionRule class="col-12">
                <div [ngClass]="{'mb-3': exchange.errors?.length > 0}" class="col-12">
                    <app-checkbox
                        [control]="exchange"
                        [formControlName]="exchange.name"
                    >
                        <ng-container text>{{ exchange.placeholder }}</ng-container>
                    </app-checkbox>
                </div>

            </div>

        </form>
    </ng-container>

</app-dialog>
